import React from 'react';
import BreadcrumbsUI5 from "../../../../../gd-components/breadcrumbs/breadcrumbs-ui5";
import {FieldViewSmallProps} from "../../../../render/view-small";


export default function FieldProject_ViewSmall(props:FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    if (!value) {
        return (
            <div className="ui5-txt-less-important txt-truncate">
                No parent
            </div>
        );
    } else {
        return <BreadcrumbsUI5 className="ultrabig-one-color" projectId={value} maxParents={2} showIcon={false} colorize={false} disabled={true}/>
    }

}
